import React, { createContext, useContext, useState } from 'react';

const HelpContext = createContext();

export const useHelp = () => useContext(HelpContext);

export const HelpProvider = ({ children }) => {
    // Standaard AAN (true) voor nieuwe gebruikers.
    // We slaan de voorkeur op in localStorage zodat de browser het onthoudt.
    const [helpMode, setHelpMode] = useState(() => {
        const saved = localStorage.getItem('propoule_help_mode');
        // Als er nog niets is opgeslagen, standaard aan (true)
        return saved !== null ? JSON.parse(saved) : true;
    });

    const toggleHelp = () => {
        setHelpMode(prev => {
            const newValue = !prev;
            localStorage.setItem('propoule_help_mode', JSON.stringify(newValue));
            return newValue;
        });
    };

    return (
        <HelpContext.Provider value={{ helpMode, toggleHelp }}>
            {children}
        </HelpContext.Provider>
    );
};
